import {isNumber} from 'lodash-es';

import {IGetEntityTypeParams, IMenuNavLink} from 'components/layout/layout-types';
import {EEntityType} from 'shared/constants/entities';
import {REFERENCE_TYPE_MENU_ITEM, EReferenceTypeMenuItemSectionCode} from 'shared/constants/layout';
import {TMenuStructure} from 'store/slices/menu-slice/menu-slice-types';

export const splitUrl = (urlToSplit: string, separator: string, currentEntityName: string): string | null => {
    const arrayOfPaths = urlToSplit.split(separator);
    let pathLocation = null;
    arrayOfPaths.forEach((path: string) => {
        if (path !== currentEntityName && !isNumber(path) && path !== '') {
            pathLocation = path;
        }
    });
    return pathLocation;
};
export const removeFileExtension = (filename?: string) => {
    if (!filename) return undefined;
    return filename.replace(/\.\w+$/, '');
};

export const getMenuNavLinks = (menuStructure: TMenuStructure | null) => {
    const headersNavLinkLists: IMenuNavLink[] = [];
    if (!menuStructure) return [];
    menuStructure.forEach(menuItem => {
        if (
            REFERENCE_TYPE_MENU_ITEM === menuItem?.itemType
            && (EReferenceTypeMenuItemSectionCode.DIADOC_CODE === menuItem?.parameters?.sectionCode
            || EReferenceTypeMenuItemSectionCode.EDISOFT_CODE === menuItem?.parameters?.sectionCode
            )
        ) {
            headersNavLinkLists.push({
                url: menuItem?.url,
                icon: removeFileExtension(menuItem?.icon?.toString()),
            });
        }
    });
    return headersNavLinkLists;
};

const ENTITY_NAMES_TO_PICK_LAST_FROM_URL = [
    'settings.user.settings',
    'directories.common.topic.settings',
    'administration.settings.programs',
    'administration.security',
    'administration.settings.drill.down',
];

export const TABLE_REPORT_ENTITY_NAME = 'table-report';

export const defineEntityName = (entityName: string, currentLocation: string | null, url: string) => {
    if (ENTITY_NAMES_TO_PICK_LAST_FROM_URL.includes(entityName)) return currentLocation || entityName;
    if (url?.match(RegExp(`^\\/${entityName}\\/(-?\\d+)`))) return TABLE_REPORT_ENTITY_NAME;
    return entityName;
};

/**
 * Определяет тип сущности для страницы.
 *
 * @param isEmptyTab - Является ли текущий элемент с типом TABS_WITH_REFERENCES пустым.
 * @param useParentItem - Следует ли использовать родительский тип сущности.
 * @param parentType - Тип сущности родительского элемента.
 * @param actualItemType - Тип сущности текущего элемента.
 */
export const getEntityType = ({
    isEmptyTab,
    useParentItem,
    parentType,
    actualItemType,
}: IGetEntityTypeParams) => {
    if (isEmptyTab) return EEntityType.TABS_WITH_REFERENCES;
    if (useParentItem) return parentType;
    return actualItemType;
};
